import React from 'react';

const Textarea: React.FunctionComponent<any> = ({ inputAttributes }): any => {
  const styles = {
    label: {
      display: 'block',
    },
  };
  return (
    <div>
      <label htmlFor={inputAttributes.id} style={styles.label}>
        {inputAttributes.title}
      </label>
      <textarea {...inputAttributes} />
    </div>
  );
};

export default Textarea;
